import {
  Gap,
  SectionHelperAppearance,
  SectionHelperBorder,
  SectionHelperLayout,
  TextSize,
  TabsType,
  LabelPlacement,
  TabsSize,
} from '@wix/design-system';

export enum BookingsBOLink {
  CALENDAR = 'calendar',
  SERVICES = 'services',
  ADD_NEW_SERVICE = 'services/templates-catalog',
}
export enum SettingsUnitsMeasures {
  Pixels = 'px',
  percent = '%',
}
export enum DESIGN_TABS_TESTS {
  GENERAL,
  HEADER,
  TABLE,
  SESSIONS,
  LOAD_MORE,
}
export const SIDEPANEL_WIDTH = '288px';
export const CHECKBOX_DIRECTION = 'vertical';
export const DISPLAY_CAN_BOOK_TOGGLE = 'medium';
export const DISPLAY_CHECKBOX_SIZE = 'small';
export const DISPLAY_CHECKBOX_ALIGNMENT = 'start';
export const DISPLAY_LOADER_ALIGNMENT = 'center';
export const DISPLAY_LOADER_SIZE = 'small';
export const DISPLAY_CAN_BOOK_TOGGLE_PROPS: {
  labelPlacement: LabelPlacement;
  labelWidth: string;
} = {
  labelPlacement: 'left',
  labelWidth: '1fr',
};
export const DESIGN_TABS = {
  NO_TAB_SELECTED: -1,
  GENERAL: 0,
  HEADER: 1,
  TABLE: 2,
  SESSIONS: 3,
  LOAD_MORE: 4,
};
export const SESSION_ITEMS_STATES = {
  REGULAR: 0,
  HOVER: 1,
  DISABLED: 2,
};
export const SETTINGS_TAB_DRILL = {
  NO_TAB_SELECTED: -1,
  DISPLAY_PREFERENCES: 0,
  SCROLL_BEHAVIOR: 1,
};

export const SLIDER_FIELD_SET: { columns: string; gap: Gap } = {
  gap: 'medium',
  columns: 'auto 63px',
};

export const WORKING_WITH_BREAKPOINTS_LINK =
  'https://support.wix.com/en/article/working-with-breakpoints';

export const STAFF_IMAGE_DISPLAY_EXPERIMENT_NAME =
  'specs.bookings.daily-agenda.staff-image-view';

export const SHOW_DISCOUNT_EXPERIMENT = 'specs.bookings.AutomaticDiscountsUoU';
export const ALLOW_DISCOUNT_FOR_BOOKING_ITEMS_EXPERIMENT =
  'specs.bookings.allowDiscountForBookingItems';

export const BREAKPOINT_TO_MOBILE: {
  appearance: SectionHelperAppearance;
  border: SectionHelperBorder;
  layout: SectionHelperLayout;
  text_size: TextSize;
} = {
  appearance: 'preview',
  border: 'topBottom',
  layout: 'horizontal',
  text_size: 'tiny',
};
export const STATES_TAB_DESIGN: { type: TabsType; size: TabsSize } = {
  type: 'uniformFull',
  size: 'small',
};

export const CATEGORIES_SPEC_NAME =
  'specs.bookings.daily-agenda.display-preferences.categories-filter';
export const GENERAL_BORDER_WIDTH_VALUES = {
  min: 0,
  max: 10,
};
export const GENERAL_BORDER_OPACITY_AND_COLOR_VALUES = {
  min: 0,
  max: 100,
};
export const GENERAL_CORNER_RADIUS_VALUES = {
  min: 0,
  max: 50,
};
export const SESSION_ITEMS_HOVER_BACKGROUND_COLOR_VALUES = {
  min: 0,
  max: 100,
};
export const SESSION_ITEMS_HOVER_BORDER_OPACITY_COLOR_VALUES = {
  min: 0,
  max: 100,
};
export const SESSION_ITEMS_REGULAR_BACKGROUND_COLOR_VALUES = {
  min: 0,
  max: 100,
};
export const SESSION_ITEMS_REGULAR_BORDER_WIDTH_VALUES = {
  min: 0,
  max: 10,
};
export const SESSION_ITEMS_REGULAR_BORDER_OPACITY_COLOR_VALUES = {
  min: 0,
  max: 100,
};
export const SESSION_ITEMS_REGULAR_CORNER_RADIUS_VALUES = {
  min: 0,
  max: 100,
};
export const LOAD_MORE_BUTTON_BACKGROUND_OPACITY_VALUES = {
  min: 0,
  max: 100,
};
export const LOAD_MORE_BUTTON_BORDER_COLOR_OPACITY_VALUES = {
  min: 0,
  max: 100,
};
export const LOAD_MORE_BORDER_WIDTH_VALUES = {
  min: 0,
  max: 10,
};
export const LOAD_MORE_BUTTON_BORDER_RADIUS_VALUES = {
  min: 0,
  max: 100,
};
export const SESSION_ITEMS_CORNER_RADIUS_VALUES = {
  min: 0,
  max: 100,
};
export const SESSION_ITEMS_IMAGE_CORNER_RADIUS_VALUES = {
  min: 0,
  max: 100,
};
export const SESSIONS_ITEMS_IMAGE_OVERLAY_OPACITY_COLOR_VALUES = {
  min: 0,
  max: 100,
};
export const TABLE_DAY_DIVIDER_OPACITY_VALUES = {
  min: 0,
  max: 100,
};
export const TABLE_DAY_DIVIDER_WIDTH_VALUES = {
  min: 1,
  max: 10,
};
export const TABLE_SESSION_DIVIDER_WIDTH_VALUES = {
  min: 0,
  max: 10,
};
export const TABLE_SESSION_DIVIDER_OPACITY_VALUES = {
  min: 0,
  max: 100,
};
export const SESSION_ITEMS_DISABLED_BACKGROUND_COLOR_VALUES = {
  min: 0,
  max: 100,
};
export const SESSION_ITEMS_DISABLED_BORDER_OPACITY_COLOR_VALUES = {
  min: 0,
  max: 100,
};
export const LAYOUT_SIDE_PADDING_VALUES = {
  min: 0,
  max: 100,
};
export const LAYOUT_TOP_PADDING_VALUES = {
  min: 0,
  max: 100,
};
export const LAYOUT_BOTTOM_PADDING_VALUES = {
  min: 0,
  max: 100,
};
export const LAYOUT_IMAGE_SIZE_VALUES = {
  min: 40,
  max: 320,
};
export const LAYOUT_ITEMS_TOP_AND_BOTTOM_PADDING_VALUES = {
  min: 0,
  max: 100,
};
export const LAYOUT_DAY_TOP_AND_BOTTOM_PADDING_VALUES = {
  min: 0,
  max: 100,
};
export const LAYOUT_DAY_SIDE_PADDING_VALUES = {
  min: 0,
  max: 100,
};
export const LAYOUT_DAY_PADDING_BETWEEN_SESSIONS_AND_DATES_VALUES = {
  min: 0,
  max: 400,
};
export const LAYOUT_DAY_PADDING_BETWEEN_HOURS_AND_ITEMS_VALUES = {
  min: 0,
  max: 200,
};
export const LAYOUT_ITEMS_ITEM_HEIGHT_VALUES = {
  min: 130,
  max: 400,
};
export const LAYOUT_ITEMS_SIDE_PADDING_VALUES = {
  min: 0,
  max: 100,
};
export const LAYOUT_SPACE_BETWEEN_ITEMS_VALUES = {
  min: 0,
  max: 100,
};
